const React = require('react');
const {AdminInput, AdminSelect} = require('../../../../../../FormInputs');
const {AdminFormRow, AdminFormCol} = require('../../../../../AdminLayout');

module.exports = ({formCtx}) => {
  return (
    <AdminFormRow>
      <AdminFormCol>
        <AdminSelect
          name="currency"
          label="Select bank primary currency"
          propValue="id"
          items={[{id: 'EUR'}, {id: 'USD'}]}
          formCtx={formCtx}
        />
      </AdminFormCol>
      <AdminFormCol>
        <AdminInput
          name="iban"
          label="IBAN / Account Number"
          formCtx={formCtx}
        />
      </AdminFormCol>
      <AdminFormCol>
        <AdminInput
          name="bank_name"
          formCtx={formCtx}
        />
      </AdminFormCol>
      <AdminFormCol>
        <AdminInput
          name="swift_code"
          formCtx={formCtx}
        />
      </AdminFormCol>
      <AdminFormCol>
        <AdminInput
          name="bank_address"
          formCtx={formCtx}
        />
      </AdminFormCol>
    </AdminFormRow>
  )
}
